import React from 'react';
import { Row, Card, Alert, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import _ from 'lodash';
import fiterAPI from '../fiterAPI';

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      currentUser: '',
      username: '',
      password: '',
      errorMessage: '',
      loading: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
  }

  async onSubmit() {
    this.setState({ loading: true });
    const { username, password } = this.state;
    try {
      await fiterAPI.login(username, password);
      this.setState({ errorMessage: '' });
      await this.props.setCurrentUser();
    } catch (err) {
      const errorMessage = _.get(
        err,
        'message',
        'Ocorreu um erro, verifique suas credenciais.'
      );
      this.setState({ errorMessage });
    } finally {
      this.setState({ loading: false });
    }
  }

  onChangeField(event, field) {
    const value = _.get(event, 'target.value');
    this.setState({ [field]: value });
  }

  render() {
    const { errorMessage, loading } = this.state;
    return (
      <Row className="justify-content-center mt-5">
        <Card style={{ width: '36rem' }} className="shadow">
          <Card.Body>
            <Card.Title>Login</Card.Title>
            <Form>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>
                  CPF
                  <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip><span>
                   Digite os 11 números do CPF sem pontos nem traços.
                    </span></Tooltip>}
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false
                      }
                    }
                  }}
                >
                  <span>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="ml-2"
                    />
                  </span>
                </OverlayTrigger>
                  </Form.Label>
                <Form.Control
                  type="email"
                  onChange={event => this.onChangeField(event, 'username')}
                />
              </Form.Group>

              <Form.Group controlId="formBasicPassword">
                <Form.Label>
                  Senha
                  <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip><span>
                    Sua senha é composta pela data do seu nascimento com 6 dígitos, sem pontos ou traços.
                    <br/>
                    Por exemplo, se você nasceu em 06/12/1960, sua senha é 061260.
                    </span></Tooltip>}
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false
                      }
                    }
                  }}
                >
                  <span>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="ml-2"
                    />
                  </span>
                </OverlayTrigger>
                  </Form.Label>
                <Form.Control
                  type="password"
                  onChange={event => this.onChangeField(event, 'password')}
                  onKeyPress={event => event.key == 'Enter' && this.onSubmit()}
                />
                
                <Form.Text className="text-muted text-right">
                  <Link to="/recuperar-senha" className="nav-link">Esqueceu a senha?</Link>
                </Form.Text>
              </Form.Group>

              {/* <div className="mb-3">
                <Link to="/cadastro">Ainda não possui conta? Cadastre-se.</Link>
              </div> */}

              {errorMessage ? (
                <Alert variant="danger">{errorMessage}</Alert>
              ) : (
                <></>
              )}

              {!loading ? (
                <Button
                  variant="primary"
                  onClick={this.onSubmit}
                  disabled={loading}
                >
                  Enviar
                </Button>
              ) : (
                <div className="spinner-border"></div>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Row>
    );
  }
}

export default Login;
